import { Category } from "@type/categories";
import { MobileTopNavbar, MobileTopNavbarItem } from "@eventsquare/uikit";
import styles from "./CategoriesFilter.module.scss";
import { useAppContext } from "@context/appContext";

const CategoriesFilter = () => {

  const { categories, activeCategory, setActiveCategory } = useAppContext();

  if (categories && categories.length <= 1) {
    return null;
  }

  return (
    <MobileTopNavbar noMargin>
      <button
        className={styles.categoryButton}
        onClick={() => setActiveCategory(undefined)}
      >
        <MobileTopNavbarItem
          label="All"
          active={activeCategory === undefined}
        />
      </button>
      {(categories as Category[]).map((category: Category) => (
        <button
          className={styles.categoryButton}
          onClick={() => setActiveCategory(category.name)}
          key={category.uid}
        >
          <MobileTopNavbarItem
            label={category.name}
            active={activeCategory === category.name}
          />
        </button>
      ))}
    </MobileTopNavbar>
  );
};

export default CategoriesFilter;